import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Successfully subscribed! Check your email for a special discount.");
      setEmail("");
    } catch (error) {
      console.error("Error subscribing:", error);
      if (error.response?.status === 400) {
        toast.error("This email is already subscribed.");
      } else {
        toast.error("Failed to subscribe. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gray-900" data-testid="newsletter-section">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Get 10% Off Your First Order
        </h2>
        <p className="text-gray-300 mb-8 text-base sm:text-lg max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
          Subscribe to our newsletter for exclusive deals, new product announcements, and customization tips.
        </p>
        <form onSubmit={handleSubmit} className="max-w-md mx-auto flex gap-4">
          <Input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-1 bg-white rounded-full"
            data-testid="newsletter-email-input"
          />
          <Button
            type="submit"
            disabled={isSubmitting}
            className="bg-white hover:bg-gray-100 text-gray-900 px-8 rounded-full transition-all duration-300"
            data-testid="newsletter-submit-btn"
          >
            {isSubmitting ? "Subscribing..." : "Subscribe"}
          </Button>
        </form>
      </div>
    </section>
  );
};

export default NewsletterSignup;